import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Resource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  unAssignPersonalCalendarHolidays(
    request: Boundaries["unAssignPersonalCalendarHolidays"]["request"],
  ): void;
}

function useUnAssignPersonalCalendarHolidays(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isUnAssignPersonalCalendarHolidaysRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isUnAssignPersonalCalendarHolidaysRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isUnAssignManagerFromResourceRequestFailure(resource),
    ),
    unAssignPersonalCalendarHolidays: core.unAssignPersonalCalendarHolidays,
  };
}

export { useUnAssignPersonalCalendarHolidays };
